
(function() {
  var result = { translations: { "es": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "es": "static-7.1218"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1218",
    "ar-eg": "static-7.1218",
    "bg": "static-7.1218",
    "bn": "static-7.1218",
    "ca-es": "static-7.1218",
    "cs": "static-7.1218",
    "da": "static-7.1218",
    "de": "static-7.1218",
    "el": "static-7.1218",
    "en-gb": "static-7.1218",
    "en": "static-7.1218",
    "es-mx": "static-7.1218",
    "es": "static-7.1218",
    "et": "static-7.1218",
    "fi": "static-7.1218",
    "fr-ca": "static-7.1218",
    "fr": "static-7.1218",
    "he-il": "static-7.1218",
    "hi": "static-7.1218",
    "hr": "static-7.1218",
    "hu": "static-7.1218",
    "id": "static-7.1218",
    "it": "static-7.1218",
    "ja": "static-7.1218",
    "ko": "static-7.1218",
    "lt": "static-7.1218",
    "ms": "static-7.1218",
    "nl": "static-7.1218",
    "no": "static-7.1218",
    "pl": "static-7.1218",
    "pt-br": "static-7.1218",
    "pt-pt": "static-7.1218",
    "ro": "static-7.1218",
    "ru": "static-7.1218",
    "sk": "static-7.1218",
    "sl": "static-7.1218",
    "sv": "static-7.1218",
    "th": "static-7.1218",
    "tl": "static-7.1218",
    "tr": "static-7.1218",
    "uk": "static-7.1218",
    "vi": "static-7.1218",
    "x-pseudo": "static-7.1218",
    "zh-cn": "static-7.1218",
    "zh-hk": "static-7.1218",
    "zh-tw": "static-7.1218"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es', {version: 'static-7.1218'}); }
})();


